import { ElementRef } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { MARKETING_SITE_DOMAIN } from 'NewAngular/constants/core.constants';
import { TrialSignupValidationService } from '../trial-signup-validation.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "ngx-cookie-service";
import * as i2 from "NewAngular/services/core/urls.service";
import * as i3 from "../trial-signup-validation.service";
import * as i4 from "@angular/common";
import * as i5 from "@angular/forms";
import * as i6 from "../../../../../../../../ycharts/static/ts/features/components/loaders/loading-symbol/loading-symbol.component";
import * as i7 from "../../../../../../../../ycharts/static/ts/features/directives/ng-model-change-debounced/ng-model-change-debounced.directive";
import * as i8 from "../../../../../../../../ycharts/static/ts/features/components/password-controls/password-reveal/password-reveal.component";
const _c0 = a0 => ({ "disabled": a0 });
const _c1 = () => ({ updateOn: "blur" });
const _c2 = a0 => ({ "is-invalid": a0 });
const _c3 = a0 => ({ "feedback feedback-invalid": a0 });
const _c4 = (a0, a1) => ({ "is-invalid": a0, "disabled": a1 });
function SignupFormComponent_div_33_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9)(1, "label", 6);
    i0.ɵɵtext(2, "Company Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "input", 33);
    i0.ɵɵtwoWayListener("ngModelChange", function SignupFormComponent_div_33_Template_input_ngModelChange_3_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r1.form.organization, $event) || (ctx_r1.form.organization = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.form.organization);
} }
function SignupFormComponent_div_34_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9)(1, "label", 6);
    i0.ɵɵtext(2, "Phone Number");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "input", 34);
    i0.ɵɵtwoWayListener("ngModelChange", function SignupFormComponent_div_34_Template_input_ngModelChange_3_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r1.form.phone, $event) || (ctx_r1.form.phone = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵlistener("debouncedChangeHandler", function SignupFormComponent_div_34_Template_input_debouncedChangeHandler_3_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.validatePhone()); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 35);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.form.phone);
    i0.ɵɵproperty("ngModelOptions", i0.ɵɵpureFunction0(5, _c1))("ngClass", i0.ɵɵpureFunction1(6, _c2, ctx_r1.errors.phone));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c3, ctx_r1.errors.phone));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.errors.phone);
} }
function SignupFormComponent_div_35_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4)(1, "div", 36)(2, "label", 6);
    i0.ɵɵtext(3, "Phone Number");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "input", 37);
    i0.ɵɵtwoWayListener("ngModelChange", function SignupFormComponent_div_35_Template_input_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r1.form.phone, $event) || (ctx_r1.form.phone = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵlistener("debouncedChangeHandler", function SignupFormComponent_div_35_Template_input_debouncedChangeHandler_4_listener() { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.validatePhone()); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 35);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 36)(8, "label", 6);
    i0.ɵɵtext(9, "Company Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "input", 38);
    i0.ɵɵtwoWayListener("ngModelChange", function SignupFormComponent_div_35_Template_input_ngModelChange_10_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r1.form.organization, $event) || (ctx_r1.form.organization = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.form.phone);
    i0.ɵɵproperty("ngModelOptions", i0.ɵɵpureFunction0(9, _c1))("ngClass", i0.ɵɵpureFunction2(10, _c4, ctx_r1.errors.phone, ctx_r1.fieldDisabled("phone-number")))("readonly", ctx_r1.fieldDisabled("phone-number"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(13, _c3, ctx_r1.errors.phone));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.errors.phone);
    i0.ɵɵadvance(4);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.form.organization);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(15, _c0, ctx_r1.fieldDisabled("organization")))("readonly", ctx_r1.fieldDisabled("organization"));
} }
function SignupFormComponent_div_36_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵtext(1, " A user with this email already exists. ");
    i0.ɵɵelementStart(2, "a", 29);
    i0.ɵɵtext(3, "Please link your account.");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c3, ctx_r1.errors.email));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("href", ctx_r1.linkAccountUrl, i0.ɵɵsanitizeUrl);
} }
function SignupFormComponent_div_36_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c3, ctx_r1.errors.email));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.errors.email, " ");
} }
function SignupFormComponent_div_36_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "div", 9)(2, "label", 6);
    i0.ɵɵtext(3, "E-mail Address");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "input", 39);
    i0.ɵɵtwoWayListener("ngModelChange", function SignupFormComponent_div_36_Template_input_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r1 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r1.form.email, $event) || (ctx_r1.form.email = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵlistener("debouncedChangeHandler", function SignupFormComponent_div_36_Template_input_debouncedChangeHandler_4_listener() { i0.ɵɵrestoreView(_r5); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.validateEmail()); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, SignupFormComponent_div_36_div_5_Template, 4, 4, "div", 40)(6, SignupFormComponent_div_36_ng_template_6_Template, 2, 4, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 9)(9, "label", 6);
    i0.ɵɵtext(10, "Password");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 41)(12, "input", 42);
    i0.ɵɵtwoWayListener("ngModelChange", function SignupFormComponent_div_36_Template_input_ngModelChange_12_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r1 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r1.form.password, $event) || (ctx_r1.form.password = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵlistener("debouncedChangeHandler", function SignupFormComponent_div_36_Template_input_debouncedChangeHandler_12_listener() { i0.ɵɵrestoreView(_r5); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.validatePassword()); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(13, "ycn-password-reveal", 43);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 35);
    i0.ɵɵtext(15);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const default_email_error_r6 = i0.ɵɵreference(7);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.form.email);
    i0.ɵɵproperty("ngModelOptions", i0.ɵɵpureFunction0(12, _c1))("ngClass", i0.ɵɵpureFunction2(13, _c4, ctx_r1.errors.email, ctx_r1.fieldDisabled("email")))("readonly", ctx_r1.fieldDisabled("email"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.linkAccountUrl && ctx_r1.errors.email === ctx_r1.DUPLICATE_EMAIL_ERROR)("ngIfElse", default_email_error_r6);
    i0.ɵɵadvance(7);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.form.password);
    i0.ɵɵproperty("ngModelOptions", i0.ɵɵpureFunction0(16, _c1))("ngClass", i0.ɵɵpureFunction2(17, _c4, ctx_r1.errors.password, ctx_r1.fieldDisabled("password")))("readonly", ctx_r1.fieldDisabled("password"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(20, _c3, ctx_r1.errors.password));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.errors.password);
} }
function SignupFormComponent_input_48_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "input", 44);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", !ctx_r1.isValidForm());
} }
function SignupFormComponent_ycn_loading_symbol_49_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-loading-symbol");
} }
export class SignupFormComponent {
    constructor(cookieService, el, urlsService, validationService) {
        this.cookieService = cookieService;
        this.urlsService = urlsService;
        this.validationService = validationService;
        this.actionUrl = '';
        this.csrfToken = '';
        this.DUPLICATE_EMAIL_ERROR = 'A user with this email address already exists. Please use a different email.';
        this.errors = { email: null, password: null, phone: null }; // pragma: allowlist secret
        this.form = {
            email: '',
            firstName: '',
            jobFunction: '',
            lastName: '',
            organization: '',
            password: '', // pragma: allowlist secret
            phone: '',
            terms: false,
        };
        this.isSaving = false;
        this.linkAccountUrl = null;
        this.loggedIn = false;
        this.nextLoginLink = '';
        this.ssoSignup = false;
        this.termsUrl = `${MARKETING_SITE_DOMAIN}/terms-of-use/`;
        this.USER = window.USER;
        this.actionUrl = el.nativeElement.getAttribute('action-url');
        this.ssoSignup = el.nativeElement.getAttribute('sso-signup') === 'True';
        this.form.email = el.nativeElement.getAttribute('email') || '';
        this.form.firstName = el.nativeElement.getAttribute('first-name') || '';
        this.form.jobFunction = el.nativeElement.getAttribute('job-function') || '';
        this.form.lastName = el.nativeElement.getAttribute('last-name') || '';
        this.form.organization = el.nativeElement.getAttribute('organization') || '';
        this.form.password = el.nativeElement.getAttribute('password') || '';
        this.form.phone = el.nativeElement.getAttribute('phone-number') || '';
        this.form.terms = el.nativeElement.getAttribute('terms') || false;
        this.disabledInputs = el.nativeElement.getAttribute('disabled-inputs') || [];
        const urlParams = new URLSearchParams(window.location.search);
        const ssoIdp = urlParams.get('sso_idp');
        if (this.ssoSignup && ssoIdp) {
            this.linkAccountUrl = this.urlsService.getUrl(this.urlsService.INTEGRATIONS.SSO_LINK_ACCOUNT, { ssoIdp });
        }
    }
    ngOnInit() {
        this.csrfToken = this.cookieService.get('csrftoken');
        this.loggedIn = this.USER.authenticated;
        this.nextLoginLink = `/login?next=${window.location.pathname}`;
        this.validateEmail();
        this.validatePassword();
        this.validatePhone();
    }
    validatePhone() {
        this.errors.phone = this.validationService.validatePhone(this.form.phone);
    }
    validateEmail() {
        if (!this.form.email) {
            this.errors.email = null;
            return;
        }
        this.validationService.validateEmail(this.form.email).subscribe((value) => {
            this.errors.email = value;
        });
    }
    validatePassword() {
        this.errors.password = this.validationService.validatePassword(this.form.password);
    }
    isValidForm() {
        return !Object.values(this.errors).some((x) => x !== null);
    }
    fieldDisabled(fieldName) {
        return this.disabledInputs.includes(fieldName);
    }
    onSubmit(e) {
        this.isSaving = true;
        const target = e.target;
        target.submit();
    }
}
SignupFormComponent.ɵfac = function SignupFormComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SignupFormComponent)(i0.ɵɵdirectiveInject(i1.CookieService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i2.UrlsService), i0.ɵɵdirectiveInject(i3.TrialSignupValidationService)); };
SignupFormComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SignupFormComponent, selectors: [["ycn-trial-signup-form"]], standalone: false, decls: 55, vars: 22, consts: [["default_email_error", ""], ["method", "post", "ngNativeValidate", "", 3, "ngSubmit", "action"], ["type", "hidden", "name", "csrfmiddlewaretoken", "autocomplete", "off", 3, "value"], [1, "auth-form"], [1, "row"], [1, "col-6", "form-row"], [1, "form-label", "form-label-thin"], ["type", "text", "placeholder", "First Name", "name", "first_name", "maxlength", "30", "required", "", 1, "form-control", 3, "ngModelChange", "ngModel", "ngClass", "readonly"], ["type", "text", "placeholder", "Last Name", "name", "last_name", "maxlength", "30", "required", "", 1, "form-control", 3, "ngModelChange", "ngModel", "ngClass", "readonly"], [1, "form-row"], [1, "select"], ["name", "job_function", "required", "", 1, "form-control", 3, "ngModelChange", "ngModel"], ["value", "", "selected", ""], ["value", "registered_investment_advisor"], ["value", "investment_professional"], ["value", "finance_professional"], ["value", "consultant_or_banker"], ["value", "personal_investor"], ["value", "student_or_educator"], ["value", "wholesaler"], ["class", "form-row", 4, "ngIf"], ["class", "row", 4, "ngIf"], [4, "ngIf"], ["id", "captcha-element"], [1, "form-row", "form-row-accept", "user-select-none"], [1, "custom-control", "custom-checkbox", "custom-checkbox-large"], ["type", "checkbox", "name", "terms", "required", "", 1, "custom-control-input", "custom-control-indicator", 3, "ngModelChange", "ngModel"], [1, "custom-control-indicator"], [1, "custom-control-description"], [3, "href"], ["type", "submit", "class", "btn btn-block btn-xxl btn-blue-ada", "value", "Get Started", 3, "disabled", 4, "ngIf"], [1, "d-flex", "flex-column", "align-items-center"], [1, "form-link"], ["type", "text", "placeholder", "Company Name", "name", "organization", "maxlength", "100", 1, "form-control", 3, "ngModelChange", "ngModel"], ["type", "text", "placeholder", "Phone Number", "name", "phone_number", "ycnNgModelChangeDebounced", "", "maxlength", "30", "required", "", 1, "form-control", 3, "ngModelChange", "debouncedChangeHandler", "ngModel", "ngModelOptions", "ngClass"], [3, "ngClass"], [1, "form-row", "col-6"], ["type", "text", "placeholder", "Phone Number", "name", "phone_number", "ycnNgModelChangeDebounced", "", "maxlength", "30", "required", "", 1, "form-control", 3, "ngModelChange", "debouncedChangeHandler", "ngModel", "ngModelOptions", "ngClass", "readonly"], ["type", "text", "placeholder", "Company Name", "name", "organization", "maxlength", "100", 1, "form-control", 3, "ngModelChange", "ngModel", "ngClass", "readonly"], ["type", "email", "placeholder", "name@company.com", "name", "email", "ycnNgModelChangeDebounced", "", "maxlength", "75", "required", "", 1, "form-control", 3, "ngModelChange", "debouncedChangeHandler", "ngModel", "ngModelOptions", "ngClass", "readonly"], [3, "ngClass", 4, "ngIf", "ngIfElse"], [1, "field-input-group", "input-group", "field-input-group-password"], ["type", "password", "placeholder", "Password", "name", "password", "id", "id_password", "ycnNgModelChangeDebounced", "", "maxlength", "50", "minlength", "8", "required", "", 1, "form-control", "field-input", 3, "ngModelChange", "debouncedChangeHandler", "ngModel", "ngModelOptions", "ngClass", "readonly"], ["passwordElementId", "id_password"], ["type", "submit", "value", "Get Started", 1, "btn", "btn-block", "btn-xxl", "btn-blue-ada", 3, "disabled"]], template: function SignupFormComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "form", 1);
        i0.ɵɵlistener("ngSubmit", function SignupFormComponent_Template_form_ngSubmit_0_listener($event) { return ctx.onSubmit($event); });
        i0.ɵɵelement(1, "input", 2);
        i0.ɵɵelementStart(2, "div", 3)(3, "div", 4)(4, "div", 5)(5, "label", 6);
        i0.ɵɵtext(6, "First Name");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "input", 7);
        i0.ɵɵtwoWayListener("ngModelChange", function SignupFormComponent_Template_input_ngModelChange_7_listener($event) { i0.ɵɵtwoWayBindingSet(ctx.form.firstName, $event) || (ctx.form.firstName = $event); return $event; });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(8, "div", 5)(9, "label", 6);
        i0.ɵɵtext(10, "Last Name");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "input", 8);
        i0.ɵɵtwoWayListener("ngModelChange", function SignupFormComponent_Template_input_ngModelChange_11_listener($event) { i0.ɵɵtwoWayBindingSet(ctx.form.lastName, $event) || (ctx.form.lastName = $event); return $event; });
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(12, "div", 9)(13, "label", 6);
        i0.ɵɵtext(14, "Job Function");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(15, "div", 10)(16, "select", 11);
        i0.ɵɵtwoWayListener("ngModelChange", function SignupFormComponent_Template_select_ngModelChange_16_listener($event) { i0.ɵɵtwoWayBindingSet(ctx.form.jobFunction, $event) || (ctx.form.jobFunction = $event); return $event; });
        i0.ɵɵelementStart(17, "option", 12);
        i0.ɵɵtext(18, "-------");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(19, "option", 13);
        i0.ɵɵtext(20, "Registered Investment Advisor");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(21, "option", 14);
        i0.ɵɵtext(22, "Investment Professional");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(23, "option", 15);
        i0.ɵɵtext(24, "Finance Professional");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(25, "option", 16);
        i0.ɵɵtext(26, "Consultant / Banker");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(27, "option", 17);
        i0.ɵɵtext(28, "Personal Investor");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(29, "option", 18);
        i0.ɵɵtext(30, "Student / Educator");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(31, "option", 19);
        i0.ɵɵtext(32, "Investment Wholesaler");
        i0.ɵɵelementEnd()()()();
        i0.ɵɵtemplate(33, SignupFormComponent_div_33_Template, 4, 1, "div", 20)(34, SignupFormComponent_div_34_Template, 6, 10, "div", 20)(35, SignupFormComponent_div_35_Template, 11, 17, "div", 21)(36, SignupFormComponent_div_36_Template, 16, 22, "div", 22);
        i0.ɵɵelementStart(37, "div", 9);
        i0.ɵɵelement(38, "div", 23);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(39, "div", 24)(40, "label", 25)(41, "input", 26);
        i0.ɵɵtwoWayListener("ngModelChange", function SignupFormComponent_Template_input_ngModelChange_41_listener($event) { i0.ɵɵtwoWayBindingSet(ctx.form.terms, $event) || (ctx.form.terms = $event); return $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵelement(42, "span", 27);
        i0.ɵɵelementStart(43, "span", 28);
        i0.ɵɵtext(44, " By checking this box you are indicating that you have read and accepted the ");
        i0.ɵɵelementStart(45, "a", 29);
        i0.ɵɵtext(46, "Terms of Use");
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(47, "div", 9);
        i0.ɵɵtemplate(48, SignupFormComponent_input_48_Template, 1, 1, "input", 30);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(49, SignupFormComponent_ycn_loading_symbol_49_Template, 1, 0, "ycn-loading-symbol", 22);
        i0.ɵɵelementStart(50, "div", 31)(51, "div", 32);
        i0.ɵɵtext(52, " Have an account? ");
        i0.ɵɵelementStart(53, "a", 29);
        i0.ɵɵtext(54, " Sign In ");
        i0.ɵɵelementEnd()()()()();
    } if (rf & 2) {
        i0.ɵɵpropertyInterpolate("action", ctx.actionUrl, i0.ɵɵsanitizeUrl);
        i0.ɵɵadvance();
        i0.ɵɵpropertyInterpolate("value", ctx.csrfToken);
        i0.ɵɵadvance(6);
        i0.ɵɵtwoWayProperty("ngModel", ctx.form.firstName);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(18, _c0, ctx.fieldDisabled("first-name")))("readonly", ctx.fieldDisabled("first-name"));
        i0.ɵɵadvance(4);
        i0.ɵɵtwoWayProperty("ngModel", ctx.form.lastName);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(20, _c0, ctx.fieldDisabled("last-name")))("readonly", ctx.fieldDisabled("last-name"));
        i0.ɵɵadvance(5);
        i0.ɵɵtwoWayProperty("ngModel", ctx.form.jobFunction);
        i0.ɵɵadvance(17);
        i0.ɵɵproperty("ngIf", !ctx.ssoSignup);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.ssoSignup);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.ssoSignup);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.loggedIn);
        i0.ɵɵadvance(5);
        i0.ɵɵtwoWayProperty("ngModel", ctx.form.terms);
        i0.ɵɵadvance(4);
        i0.ɵɵpropertyInterpolate("href", ctx.termsUrl, i0.ɵɵsanitizeUrl);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", !ctx.isSaving);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.isSaving);
        i0.ɵɵadvance(4);
        i0.ɵɵpropertyInterpolate("href", ctx.nextLoginLink, i0.ɵɵsanitizeUrl);
    } }, dependencies: [i4.NgClass, i4.NgIf, i5.NgSelectOption, i5.ɵNgSelectMultipleOption, i5.DefaultValueAccessor, i5.CheckboxControlValueAccessor, i5.SelectControlValueAccessor, i5.NgControlStatus, i5.NgControlStatusGroup, i5.RequiredValidator, i5.MinLengthValidator, i5.MaxLengthValidator, i5.CheckboxRequiredValidator, i5.NgModel, i5.NgForm, i6.LoadingSymbolComponent, i7.NgModelChangeDebouncedDirective, i8.PasswordRevealComponent], encapsulation: 2 });
